import React from "react";
import Icon from "../../common/Icon/Icon";
import styles from "./ProfileTabs.module.css";
import ActiveLink from "../../common/ActiveLink";

const ProfileTabs = () => (
    <nav className={styles.ProfileTabs}>
        <ActiveLink href="/profile" className={styles.ProfileTabItem} activeClassName={styles.ProfileTabItemActive}>
            <Icon icon="settings" />
            Profile settings
        </ActiveLink>

        <ActiveLink href="/profile/security-settings" className={styles.ProfileTabItem} activeClassName={styles.ProfileTabItemActive}>
            <Icon icon="key" />
            Security settings
        </ActiveLink>

        <ActiveLink href="/profile/notification-settings" className={styles.ProfileTabItem} activeClassName={styles.ProfileTabItemActive}>
            <Icon icon="bell" />
            Notification settings
        </ActiveLink>
    </nav>
);

export default ProfileTabs;
